import { ReactElement, ReactNode } from 'react'
import styled from 'styled-components'

import Image from 'components/common/Image'

import arrowLeft from 'assets/images/arrow-left.svg'

interface Props extends React.HTMLAttributes<HTMLElement> {
    onClose?: () => void
    children: ReactNode
}

const Sheet = ({ onClose, children }: Props): ReactElement => {
    return (
        <Container>
            <Header>
                {onClose && (
                    <Image
                        className="cursor-pointer"
                        src={arrowLeft}
                        height="12px"
                        width="14px"
                        onClick={onClose}
                        data-testid="close-sheet-icon"
                    />
                )}
            </Header>
            <Content data-testid="sheet-content">{children}</Content>
        </Container>
    )
}

const Container = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    background: ${({ theme }) => theme.colors.white};
`

const Header = styled.div`
    height: 3.375rem;
    background: ${({ theme }) => theme.colors.white};
    display: flex;
    align-items: center;
    padding-left: 1.3125rem;
`

const Content = styled.div`
    overflow-y: auto;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: stretch;
`

export default Sheet
